import { render, staticRenderFns } from "./BacklogPage.vue?vue&type=template&id=f70f36b0"
import script from "./BacklogPage.vue?vue&type=script&lang=js"
export * from "./BacklogPage.vue?vue&type=script&lang=js"
import style0 from "@/assets/scss/_backlog.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports